import { isBrowser } from "../functions/is-browser.qwik.mjs";
import { logger } from "./logger.qwik.mjs";
import { checkIsDefined } from "./nullable.qwik.mjs";
import { getTopLevelDomain } from "./url.qwik.mjs";
const getCookieSync = ({ name, canTrack }) => {
  var _a;
  try {
    if (!canTrack)
      return void 0;
    return (_a = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`))) == null ? void 0 : _a.split("=")[1];
  } catch (err) {
    logger.warn("[COOKIE] GET error: ", (err == null ? void 0 : err.message) || err);
    return void 0;
  }
};
const getCookie = async (args) => getCookieSync(args);
const stringifyCookie = (cookie) => cookie.map(([key, value]) => value ? `${key}=${value}` : key).filter(checkIsDefined).join("; ");
const SECURE_CONFIG = [
  [
    "secure",
    ""
  ],
  [
    "SameSite",
    "None"
  ]
];
const createCookieString = ({ name, value, expires }) => {
  const secure = isBrowser() ? location.protocol === "https:" : true;
  const secureObj = secure ? SECURE_CONFIG : [
    []
  ];
  const expiresObj = expires ? [
    [
      "expires",
      expires.toUTCString()
    ]
  ] : [
    []
  ];
  const cookieValue = [
    [
      name,
      value
    ],
    ...expiresObj,
    [
      "path",
      "/"
    ],
    [
      "domain",
      getTopLevelDomain(window.location.hostname)
    ],
    ...secureObj
  ];
  const cookie = stringifyCookie(cookieValue);
  return cookie;
};
const setCookie = async ({ name, value, expires, canTrack }) => {
  try {
    if (!canTrack)
      return;
    const cookie = createCookieString({
      name,
      value,
      expires
    });
    document.cookie = cookie;
  } catch (err) {
    logger.warn("[COOKIE] SET error: ", (err == null ? void 0 : err.message) || err);
  }
};
export {
  getCookie,
  getCookieSync,
  setCookie
};
